var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "chartContainer",
      staticStyle: {
        padding: "0",
        width: "100%",
        height: "100%",
        overflow: "hidden",
      },
      style: _vm.bg_class,
    },
    [
      _c("view-track-bar", {
        ref: "viewTrack",
        staticClass: "track-bar",
        style: _vm.trackBarStyleTime,
        attrs: { "track-menu": _vm.trackMenu },
        on: { trackClick: _vm.trackClick },
      }),
      _vm.chart.type
        ? _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.title_show,
                  expression: "title_show",
                },
              ],
              ref: "title",
              staticStyle: { cursor: "default", display: "block" },
              style: _vm.title_class,
            },
            [
              _c(
                "div",
                { staticStyle: { padding: "4px 4px 0", margin: "0" } },
                [
                  _c("chart-title-update", {
                    attrs: {
                      "title-class": _vm.title_class,
                      "chart-info": _vm.chartInfo,
                    },
                  }),
                  _vm.remarkCfg.show
                    ? _c("title-remark", {
                        staticStyle: {
                          "text-shadow": "none!important",
                          "margin-left": "4px",
                        },
                        attrs: { "remark-cfg": _vm.remarkCfg },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        {
          ref: "tableContainer",
          staticStyle: { width: "100%", overflow: "hidden" },
          style: { background: _vm.container_bg_class.background },
        },
        [
          _vm.chart.type === "table-normal"
            ? _c("div", {
                class: _vm.chart.drill
                  ? "table-dom-normal-drill"
                  : "table-dom-normal",
                staticStyle: { width: "100%", overflow: "hidden" },
                attrs: { id: _vm.chartId },
              })
            : _vm._e(),
          _vm.chart.type === "table-info"
            ? _c("div", {
                class: _vm.chart.drill
                  ? _vm.showPage
                    ? "table-dom-info-drill"
                    : "table-dom-info-drill-pull"
                  : _vm.showPage
                  ? "table-dom-info"
                  : "table-dom-info-pull",
                staticStyle: { width: "100%", overflow: "hidden" },
                attrs: { id: _vm.chartId },
              })
            : _vm._e(),
          _vm.chart.type === "table-pivot"
            ? _c("div", {
                staticClass: "table-dom-normal",
                staticStyle: { width: "100%", overflow: "hidden" },
                attrs: { id: _vm.chartId },
              })
            : _vm._e(),
          _c(
            "el-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showPage,
                  expression: "showPage",
                },
              ],
              staticStyle: { position: "relative" },
            },
            [
              _c(
                "el-row",
                { staticClass: "table-page", style: _vm.autoStyle },
                [
                  _c(
                    "span",
                    { staticClass: "total-style", style: _vm.totalStyle },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("chart.total")) +
                          "\n          "
                      ),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.chart.datasetMode === 0 &&
                              !_vm.not_support_page_dataset.includes(
                                _vm.chart.datasourceType
                              )
                              ? _vm.chart.totalItems
                              : _vm.chart.data && _vm.chart.data.tableRow
                              ? _vm.chart.data.tableRow.length
                              : 0
                          )
                        ),
                      ]),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("chart.items")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _c("de-pagination", {
                    staticClass: "page-style",
                    attrs: {
                      small: "",
                      "current-page": _vm.currentPage.page,
                      "page-size": _vm.currentPage.pageSize,
                      "pager-count": 5,
                      "custom-style": {
                        color: _vm.title_class.color,
                      },
                      layout: "prev, pager, next",
                      total: _vm.currentPage.show,
                    },
                    on: {
                      "current-change": _vm.pageClick,
                      "size-change": _vm.pageChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }